<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<div class="img_container4">
<img alt="images" src="images/f0001-01.jpg"/>
</div>
<h1 class="title"><span class="bold">A–Z</span></h1>
<h1 class="title1">of</h1>
<h1 class="title0"><span class="bold">SEWING</span></h1>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?8c0e9e26